import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetSubscriptionStatusRequestDtoSchema = z.object({
  comparisonSet: z.enum(['INTERNAL', 'COMP']),
  facilityId: z.number(),
});

const GetSubscriptionStatusResponseDtoSchema = z.object({
  isActive: z.boolean(),
});

export type GetSubscriptionStatusRequestDto = z.infer<
  typeof _GetSubscriptionStatusRequestDtoSchema
>;
export type GetSubscriptionStatusResponseDto = z.infer<
  typeof GetSubscriptionStatusResponseDtoSchema
>;

export const getSubscriptionStatus = (
  params: GetSubscriptionStatusRequestDto,
  config?: AxiosRequestConfig<GetSubscriptionStatusRequestDto>
) => {
  return api
    .get('market-intel-subscription/status', { params, ...config })
    .then(responseContract(GetSubscriptionStatusResponseDtoSchema));
};
